import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { useMemo } from "react";
import { isNotUndefined } from "../FunctionsCore";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import DrsSealStyles from "./DrsSeal.module.scss";
import { sealImages } from "./resources/images";
const styles = DrsSealStyles;
const classCombiner = classCombinerFromPrefix("7a6bfadd6bdecca1");
const DrsSeal = (props) => {
    var _a;
    const { companyOverview, properties } = props;
    const { isDrs } = companyOverview;
    const meritSealRankImg = useMemo(() => {
        if (isDrs) {
            // Default or global one
            let sealImgName = "dunsRegisteredSeal";
            if (isNotUndefined(companyOverview.isHu) && isNotUndefined(companyOverview.meritScore)) {
                sealImgName = `${companyOverview.meritColor}${companyOverview.meritScore}`;
            }
            return sealImages[sealImgName];
        }
        return "";
    }, [companyOverview, isDrs]);
    // This component is used for DRS and AAA rating(hu)
    if (!(isDrs && isNotUndefined(meritSealRankImg))) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", Object.assign({ className: cx(classCombiner(styles, "drsSection")) }, { children: [_jsx("div", { className: cx(classCombiner(styles, "drsImage")), style: { "backgroundImage": `url(${meritSealRankImg})`, "backgroundRepeat": "no-repeat" } }), _jsx("div", Object.assign({ className: cx(classCombiner(styles, "drsText")) }, { children: (_a = properties.drsContentLocalized) !== null && _a !== void 0 ? _a : "A D-U-N-S® Registered Seal indicates that a company has been assigned a Dun & Bradstreet D-U-N-S® Number" }))] })));
};
const drsSeal = (renderableData) => renderIdentifierGeneric(DrsSeal, renderableData);
export { drsSeal };
